import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {EventDTO} from "../models/eventDTO.model";

@Injectable({
  providedIn: "root",
})
export class EventsService {
  constructor(private httpClient: HttpClient) {}

  getAllEvents(): Observable<EventDTO[]> {
    return this.httpClient.get<EventDTO[]>(
      environment.baseUrl + "/events"
    );
  }

}
